import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface WatchlistItem {
  Aff: string;
  ABONo: string;
  IsoCountry?: string;
  PrivacyFlag?: boolean;
}

export type WatchlistState = {
  watchlistItems: WatchlistItem[];
  initialItems: WatchlistItem[];
  initialized: boolean;
  impersonationItems: WatchlistItem[];
  impersonationInitialized: boolean;
};

export const initialState: WatchlistState = {
  watchlistItems: [],
  initialItems: [],
  initialized: false,
  impersonationItems: [],
  impersonationInitialized: false,
};

const { actions, reducer } = createSlice({
  name: "watchlist",
  initialState,
  reducers: {
    initWatchlistItems: (state, action: PayloadAction<WatchlistItem[]>) => {
      if (!state.initialized) {
        state.watchlistItems = action.payload;
        state.initialItems = action.payload;
        state.initialized = true;
      }
    },
    setWatchlistItems: (state, action: PayloadAction<WatchlistItem[]>) => {
      state.watchlistItems = action.payload;
    },
    setImpersonationWatchlistItems: (state, action: PayloadAction<WatchlistItem[]>) => {
      state.impersonationItems = action.payload;
      state.impersonationInitialized = true;
    },
    initImpersonationWatchlistItems: (state, action: PayloadAction<WatchlistItem[]>) => {
      if (!state.impersonationInitialized) {
        state.impersonationItems = action.payload;
        state.impersonationInitialized = true;
      }
    },
    resetImpersonationWatchlistItems: (state) => {
      state.impersonationItems = [];
      state.impersonationInitialized = false;
    },
    resetWatchlistInitialized: (state) => {
      state.initialized = false;
    },
  },
});

export const {
  initWatchlistItems,
  setWatchlistItems,
  resetWatchlistInitialized,
  initImpersonationWatchlistItems,
  setImpersonationWatchlistItems,
  resetImpersonationWatchlistItems,
} = actions;

export default reducer;
